import React from 'react';
import PropTypes from 'prop-types';

export const AuthProvider = ({children}) => {
  return <Provider>{children}</Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const Provider = ({children}) => {
  return children;
};

Provider.propTypes = {
  children: PropTypes.node.isRequired
};
